<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Редактировать адрес
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'address-details', params: { address_id: address.id }}">← Назад к Деталям адреса</router-link>
    </div>

    <div class="text-right">
      <a v-if="address.id" class="red" href="#" @click.prevent="deleteAddress">удалить адрес</a>
    </div>

    <address-edit-form
      :address="address"
      @after="handleAfter"
    />

  </div>
</template>

<script>
import { getAddress, deleteAddress } from '@/services/address.service'
import addressEditForm from '@/components/forms/address/AddressEditForm'

export default {
  name: 'address-edit',
  components: { addressEditForm },
  data () {
    return {
      address: {
        id: null,
        name: '',
        district: ''
      },

      errors: {
        address: {
          id: [],
          name: [],
          district: []
        },
        non_field_errors: []
      }
    }
  },
  mounted () {
    if (this.$route.params.address_id !== undefined) {
      this.address.id = this.$route.params.address_id

      getAddress(this.address.id).then((response) => {
        this.address = response.data
      })
    }
  },
  methods: {
    deleteAddress () {
      deleteAddress(this.address.id).then((response) => {
        this.showMsg('Адрес был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'district-details', params: { district_id: this.$route.params.district_id } })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Адрес был удален!', 'success', 'Успешно')
        this.$router.push({ name: 'district-details', params: { district_id: this.$route.params.district_id } })
        return true
      })
    },
    handleAfter (success) {
      console.log(success)
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// AddressEdit.vue?04cf236d